import { create } from 'zustand';
import { getExternalTalent, getInternalTalent } from '@libs/api/talents';
import { StaffViewInfo } from '@libs/models/talents/talent';

type InitialState = {
  loading: boolean;
  initiated: boolean;
  data: StaffViewInfo | null;
  open: boolean;
  load: (id: string, type: 'internal' | 'external', silent?: boolean) => Promise<void>;
  openDrawer: (id: string, type: 'internal' | 'external') => Promise<void>;
  closeDrawer: () => void;
};

export const useViewProviderInfoStore = create<InitialState>()((set, get) => ({
  loading: false,
  initiated: false,
  data: null,
  open: false,

  load: async (id: string, type: 'internal' | 'external', silent?: boolean) => {
    !silent &&
      set({
        loading: true,
      });
    try {
      const talent = await (type === 'internal' ? getInternalTalent(id) : getExternalTalent(id));
      set({
        data: talent,
        initiated: true,
        loading: false,
      });
    } finally {
      !silent &&
        set({
          loading: false,
        });
    }
  },
  openDrawer: async (id: string, type: 'internal' | 'external') => {
    set({ open: true });
    await get().load(id, type);
  },
  closeDrawer: () => {
    set({
      open: false,
      data: null,
      loading: false,
      initiated: false,
    });
  },
}));
